const copyToClipboard = (content: string) => {
  return navigator.clipboard.writeText(content);
};
export default copyToClipboard;
